import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  ImageListItem,
  TextField,
} from "@mui/material";
import logo from "../../assets/images/Left.png";
import Maskgroup from "../../assets/icons/Maskgroup.svg";
import "./login.css";
import Eye from "../../assets/icons/Eye.svg";
import EyeIcon from "../../assets/icons/EyeIcon.svg";
import Arrowicon from "../../assets/icons/Arrow.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  userSignin,
  userSigninWithUserName,
  setLoaderUserLogin,
  isForgotPassword
} from "../../redux/actions/userActions";
import { TOKEN } from "../../utils/localStorage";
import { getCookie } from "cookies-next";
import { ToastContainer, toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";

const styles = {
  imageListItem: {
    backgroundImage: `url(${logo})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  leftText: {
    marginTop: "30px",
    fontSize: "25px",
    fontWeight: 600,
    color: "#FFFFFF",
    margin: "10px",
  },
  contentBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh !important",
  },

  button: {
    fontSize: "25px",
    fontWeight: "bold",
    backgroundColor: "#FFFFFF",
    padding: "8px 15px 5px 15px",
    margin: "30px 10px 5px 0px",
    borderRadius: "8px",
    color: "#20704D",
    ":hover": {
      backgroundColor: "#FFFFFF",
    },
  },
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoginLoading = useSelector((state) => state?.user?.isLoginLoading);

  const [loginData, setLoginData] = useState({
    email: null,
    password: null,
  });
  const [showPassword, setShowPassword] = useState(false);

  const [validationError, setValidationError] = useState(false);
  const userLoginDetails = useSelector((state) => state?.user?.userData);

  const handleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const onEmailSet = (e) => {
    setLoginData({ ...loginData, email: e.target.value });
  };

  const onPasswordSet = (e) => {
    setLoginData({ ...loginData, password: e.target.value });
  };

  const onSubmit = async (event) => {
      event.preventDefault();
      if (loginData.email !== null && loginData.password !== null) {
        setValidationError(false);
        const emailPattern =
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (emailPattern.test(loginData.email)) {
          dispatch(
            userSignin({
              email: loginData.email,
              password: loginData.password,
            })
          );
        } else {
          dispatch(
            userSigninWithUserName({
              username: loginData.email,
              password: loginData.password,
            })
          );
        }
      } else {
        setValidationError(true);
      }
  };



  useEffect(() => {
    const cookiesData = getCookie(TOKEN);
    if (cookiesData) {
      navigate("/dashboard");
    }
  }, [userLoginDetails]);

  useEffect(() => {
    dispatch(setLoaderUserLogin(false));
    dispatch(isForgotPassword(false));
  }, []);



  return (
    <Box className="login">
      {/* <ToastContainer /> */}
      {/*----------------------------login leftbar ---------------------------- /> */}
      <Box className="login_left_side">
        <ImageListItem sx={styles.imageListItem}>
          <Box sx={styles.contentBox}>
            <Box>
              <ImageListItem sx={{ margin: "10px" }}>
                <img src={Maskgroup} alt="" />
              </ImageListItem>
            </Box>

            <Box>
              <Typography sx={styles.leftText} align="center">
                Planned Maintenance System (PMS)
              </Typography>
            </Box>
            <Box>
              <Typography sx={styles.button}>Harbour Tugs</Typography>
            </Box>
          </Box>
        </ImageListItem>
      </Box>
      {/*----------------------------login rightbar ---------------------------- /> */}
      <Box className="login_right_side">
        <Box className="login_header_box">
              <>
              <form onSubmit={onSubmit}>
                <Box sx={{ marginBottom: "70px" }}>
                  <Typography
                    sx={{ fontSize: "30px", fontWeight: 600, color: "#2F3044" }}
                  >
                    Let’s Login Now
                  </Typography>
                  <Typography
                    sx={{
                      color: "#A7A8BB",
                      fontSize: "18px",
                      fontWeight: 500,
                      lineHeight: "30px",
                    }}
                  >
                    Welcome back, you’ve been missed!
                  </Typography>
                </Box>
                <Box sx={{ marginTop: "20px" }}>
                  <Typography
                    sx={{ fontSize: "15px", fontWeight: 600, color: "#2F3044" }}
                  >
                    Email ID or Username
                  </Typography>
                  <Box className="input_container">
                    <input
                      type="text"
                      className="input_field"
                      value={loginData.email}
                      onChange={onEmailSet}
                      placeholder="Enter Your Email Address"
                      // required
                    />
                  </Box>
                  {validationError && (
                    <Box>
                      <Typography
                        sx={{
                          marginTop: "5px",
                          fontSize: "15px",
                          color: "red",
                        }}
                      >
                        Please enter email address
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ marginTop: "20px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight: 600,
                        color: "#2F3044",
                      }}
                    >
                      Password
                    </Typography>
                  </Box>
                  <Box className="input_container">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="input_field"
                      value={loginData.password}
                      onChange={onPasswordSet}
                      placeholder="Enter Your Password"
                      // required
                    />
                    <img
                      src={showPassword ? Eye : EyeIcon}
                      alt=""
                      className="end_icon_class"
                      onClick={handleShowPassword}
                    />
                  </Box>
                  {validationError && (
                    <Box>
                      <Typography
                        sx={{
                          marginTop: "5px",
                          fontSize: "15px",
                          color: "red",
                        }}
                      >
                        Please enter password
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box
                  sx={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                    cursor:"pointer",
                    
                    
                  }}
                >
                  <Typography sx={{color:"#26875C",fontWeight:"600",textDecoration: "underline"}}  onClick={() => {
                      navigate("/forgotpassword");
                    }}>
                    Forgot Password
                  </Typography>
                </Box>
                <Box
                  sx={{
                    marginTop: "20px",
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <LoadingButton
                    // onClick={onSubmit}
                    // disabled={validationError}
                    type="submit"
                    variant="contained"
                    sx={{
                      fontSize: "15px",
                      fontWeight: 600,
                      backgroundColor: "#26875C",
                      padding: "10px 30px 8px 30px",
                      textTransform: "capitalize",
                      borderRadius: "8px",
                      color: "#FFFFFF",
                      ":hover": {
                        backgroundColor: "#26875C",
                      },
                    }}
                    size="large"
                    loading={isLoginLoading}
                  >
                    Login
                    <Box sx={{ marginLeft: "10px" }}>
                      <img src={Arrowicon} alt="" />
                    </Box>
                  </LoadingButton>
                </Box>
                </form>
              </>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
